import * as React from 'react'
export const LogoChrome = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={102} height={100} {...props}>
    <g fill="none">
      <path
        fill="#E16B5A"
        d="M50.768.01s30.01-1.325 45.916 28.249H48.217s-9.154-.296-16.957 10.594c-2.25 4.561-4.65 9.27-1.95 18.538-3.9-6.472-20.708-35.164-20.708-35.164S20.457 1.186 50.768.009z"
      />
      <path
        fill="#FFD464"
        d="M95.122 75.095S81.284 101.238 47.21 99.952C51.414 92.82 71.45 58.8 71.45 58.8s4.837-7.626-.875-19.696c-2.903-4.192-11.7-8.586-21.237-10.928 7.67-.075 47.25.005 47.25.005s12.653 20.59-1.466 46.915z"
      />
      <path
        fill="#74B340"
        d="M6.628 75.294s-16.17-24.825 2.004-53.116l24.225 41.163s4.314 7.92 17.832 9.104c5.153-.368 10.514-.682 17.351-7.607C64.27 71.387 47.327 100 47.327 100s-24.51.448-40.7-24.706z"
      />
      <ellipse cx={50.646} cy={50.406} fill="#FFF" rx={23.064} ry={22.656} />
      <ellipse cx={50.638} cy={50.406} fill="#2995CC" rx={18.292} ry={17.969} />
      <path
        fill="#268CBF"
        d="M50.643 32.441c-.364 0-.724.014-1.082.034 9.598.55 17.209 8.369 17.209 17.934 0 9.568-7.611 17.386-17.21 17.937.36.02.72.034 1.083.034 10.101 0 18.292-8.046 18.292-17.97 0-9.923-8.19-17.969-18.292-17.969z"
      />
    </g>
  </svg>
)
